import { render, staticRenderFns } from "./UserLicense.vue?vue&type=template&id=7524c83b&"
import script from "./UserLicense.vue?vue&type=script&lang=js&"
export * from "./UserLicense.vue?vue&type=script&lang=js&"
import style0 from "./UserLicense.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports